const ads = [
  {
    id: "123gold",
    title: "123 Gold",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/123gold_desktop.gif"
        alt="123 Gold"
        title="123 Gold"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/123gold_mobile.gif"
        alt="123 Gold"
        title="123 Gold"
      />
    ),
    link: "https://www.123gold.de/en/",
    time: 10000,
  },
  {
    id: "alcatel",
    title: "Alcatel Lucent",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/alcatel_desktop.gif"
        alt="Alcatel Lucent"
        title="Alcatel Lucent"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/alcatel_mobile.gif"
        alt="Alcatel Lucent"
        title="Alcatel Lucent"
      />
    ),
    link: "https://www.al-enterprise.com/en/",
    time: 8000,
  },
  {
    id: "bayern",
    title: "Bayern Tourismus",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/bayern_desktop.gif"
        alt="Bayern Tourismus"
        title="Bayern Tourismus"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/bayern_mobile.gif"
        alt="Bayern Tourismus"
        title="Bayern Tourismus"
      />
    ),
    link: "https://bavaria.travel/",
    time: 8000,
  },
  {
    id: "benediktiner",
    title: "Benediktiner",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/benediktiner_desktop.gif"
        alt="Benediktiner"
        title="Benediktiner"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/benediktiner_mobile.gif"
        alt="Benediktiner"
        title="Benediktiner"
      />
    ),
    link: "https://www.benediktiner-weissbier.de/en/",
    time: 9400,
  },
  {
    id: "cobra",
    title: "Cobra",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/cobra_desktop.gif"
        alt="Cobra"
        title="Cobra"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/cobra_mobile.gif"
        alt="Cobra"
        title="Cobra"
      />
    ),
    link: "https://www.cobragolf.com/en-eu/collections/ds-adapt",
    time: 8000,
  },
  {
    id: "commercetools",
    title: "Commercetools",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/commercetools_desktop.gif"
        alt="Commercetools"
        title="Commercetools"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/commercetools_mobile.gif"
        alt="Commercetools"
        title="Commercetools"
      />
    ),
    link: "https://commercetools.com/",
    time: 8000,
  },
  {
    id: "dpworld",
    title: "DP World",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/dpworld_desktop.gif"
        alt="DP World"
        title="DP World"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/dpworld_mobile.gif"
        alt="DP World"
        title="DP World"
      />
    ),
    link: "https://www.dpworld.com",
    time: 8000,
  },
  {
    id: "emirates",
    title: "Emirates",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/emirates_desktop.gif"
        alt="Emirates"
        title="Emirates"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/emirates_mobile.gif"
        alt="Emirates"
        title="Emirates"
      />
    ),
    link: "https://www.emirates.com",
    time: 8000,
  },
  {
    id: "emirates",
    title: "Flughafen München",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/flughafenmuenchen_desktop.gif"
        alt="Flughafen München"
        title="Flughafen München"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/flughafenmuenchen_mobile.gif"
        alt="Flughafen München"
        title="Flughafen München"
      />
    ),
    link: "https://parken.munich-airport.de",
    time: 8000,
  },
  {
    id: "gerardbertrand",
    title: "Gerard Bertrand",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/gerardbertrand_desktop.gif"
        alt="Gerard Bertrand"
        title="Gerard Bertrand"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/gerardbertrand_mobile.gif"
        alt="Gerard Bertrand"
        title="Gerard Bertrand"
      />
    ),
    link: "https://www.gerard-bertrand.de",
    time: 9000,
  },
  {
    id: "goodyear",
    title: "Goodyear",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/goodyear_desktop.gif"
        alt="Goodyear"
        title="Goodyear"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/goodyear_mobile.gif"
        alt="Goodyear"
        title="Goodyear"
      />
    ),
    link: "https://www.goodyear.eu",
    time: 8000,
  },
  {
    id: "husqvarna",
    title: "Husqvarna",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/husqvarna_desktop.gif"
        alt="Husqvarna"
        title="Husqvarna"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/husqvarna_mobile.gif"
        alt="Husqvarna"
        title="Husqvarna"
      />
    ),
    link: "https://www.husqvarna.com/",
    time: 8000,
  },
  {
    id: "jacobs",
    title: "Jacobs",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/jacobs_desktop.gif"
        alt="Jacobs"
        title="Jacobs"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/jacobs_mobile.gif"
        alt="Jacobs"
        title="Jacobs"
      />
    ),
    link: "https://www.jacobskaffee.de/produkte/?filters=ESPRESSO+KAPSELN",
    time: 8000,
  },
  {
    id: "moutai",
    title: "Moutai",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/moutai_desktop.gif"
        alt="Moutai"
        title="Moutai"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/moutai_mobile.gif"
        alt="Moutai"
        title="Moutai"
      />
    ),
    link: "https://www.moutaichina.com/mtgfen/index/index.html",
    time: 8000,
  },
  {
    id: "puma",
    title: "Puma",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/puma_desktop.gif"
        alt="Puma"
        title="Puma"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/puma_mobile.gif"
        alt="Puma"
        title="Puma"
      />
    ),
    link: "https://eu.puma.com/de/en/pd/puma-royale-golf-shoes-men/310726.html?dwvar_310726_color=01",
    time: 8000,
  },
  {
    id: "rlvg",
    title: "Rheinland Versicherungsgruppe",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/rlvg_desktop.gif"
        alt="Rheinland Versicherungsgruppe"
        title="Rheinland Versicherungsgruppe"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/rlvg_mobile.gif"
        alt="Rheinland Versicherungsgruppe"
        title="Rheinland Versicherungsgruppe"
      />
    ),
    link: "https://www.rheinland-versicherungsgruppe.de/en/",
    time: 8000,
  },
  {
    id: "rolex",
    title: "Rolex",
    imgDesktop: (
      <iframe
        title="Rolex"
        src="https://static.rolex.com/clocks/2022/bmw_golfsport_desk_en_HTML_1250x140/rolex.html"
        style={{
          width: "1250px",
          height: "140px",
          border: "0",
          margin: "0",
          padding: "0",
          overflow: "hidden",
          //scroll: 'none'
        }}
        scrolling="no"
        frameBorder="no"
      />
    ),
    imgMobile: (
      <iframe
        title="Rolex"
        src="https://static.rolex.com/clocks/2022/bmw_golfsport_mobile_en_HTML_320x110/rolex.html"
        style={{
          width: "320px",
          height: "110px",
          border: "0",
          margin: "0",
          padding: "0",
          overflow: "hidden",
          //scroll: "none",
        }}
        scrolling="no"
        frameBorder="no"
      />
    ),
    link: "https://www.rolex.com/",
    time: 9000,
  },
  {
    id: "securitas",
    title: "Securitas",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/securitas_desktop.gif"
        alt="Securitas"
        title="Securitas"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/securitas_mobile.gif"
        alt="Securitas"
        title="Securitas"
      />
    ),
    link: "https://www.securitas.com/",
    time: 8000,
  },
  {
    id: "georgs",
    title: "St. Leonhards Quellen",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/georgs_desktop.gif"
        alt="St. Leonhards Quellen"
        title="St. Leonhards Quellen"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/georgs_mobile.gif"
        alt="St. Leonhards Quellen"
        title="St. Leonhards Quellen"
      />
    ),
    link: "https://www.st-georgsquelle.de/",
    time: 8000,
  },
  {
    id: "stroeer",
    title: "Ströer",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/stroeer_desktop.gif"
        alt="Ströer"
        title="Ströer"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/stroeer_mobile.gif"
        alt="Ströer"
        title="Ströer"
      />
    ),
    link: "https://www.stroeer.de/en/",
    time: 8000,
  },
  {
    id: "sz",
    title: "Süddeutsche Zeitung",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/sz_desktop.gif"
        alt="Süddeutsche Zeitung"
        title="Süddeutsche Zeitung"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/sz_mobile.gif"
        alt="Süddeutsche Zeitung"
        title="Süddeutsche Zeitung"
      />
    ),
    link: "https://produkte.sueddeutsche.de/angebotsseite/?wt=OFFLBOST23&utm_source=bmwopen&utm_medium=banner&utm_campaign=standard",
    time: 8000,
  },
  {
    id: "taittinger",
    title: "Tattinger",
    imgDesktop: (
      <img
        src="/assets/images/partner/2025/taittinger_desktop.jpg"
        alt="Tattinger"
        title="Tattinger"
      />
    ),
    imgMobile: (
      <img
        src="/assets/images/partner/2025/taittinger_mobile.jpg"
        alt="Tattinger"
        title="Tattinger"
      />
    ),
    link: "https://www.taittinger.com",
    time: 8000,
  },
];

export default ads;
